import Vue from "vue";
import Vuex from "vuex";

import user from "./modules/user";
import routes from "./modules/routes";
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    routes
  },
  plugins: [createPersistedState({
    storage:window.sessionStorage
  })],
})


export default store



// WEBPACK FOOTER //
// ./src/store/index.js